// ============================================================
// หน้า Loading — หน้าแรกสุดของระบบ (path "/")
// ------------------------------------------------------------
// ไม่แสดงอะไร ทำหน้าที่ตัดสินใจอย่างเดียวว่าจะพาผู้ใช้ไปไหนต่อ
//   ล็อกอินค้างไว้ + เลือกโครงการแล้ว → หน้าแรกที่ผู้ใช้มีสิทธิ์ (first_page)
//   ล็อกอินค้างไว้ + ยังไม่เลือกโครงการ → หน้าเลือกโครงการ
//   ไม่มี session → ล้างของค้างแล้วไปหน้าล็อกอิน
// ============================================================

import React, { Component } from "react";

import "../../assets/css/bootstrap.css";
import { tokens, removeStorage, getStorage } from "../../shared/index.js";

export default class Loading extends Component {
  componentDidMount() {
    const first_page = getStorage("first_page");
    const project_id = getStorage("project_id");

    if (tokens && first_page) {
      window.location.href = project_id ? first_page : "/choose-project";
      return;
    }

    removeStorage();
    window.location.href = "/login";
  }

  render() {
    return <div></div>;
  }
}

